import { createContext, useContext, useState, useEffect } from 'react';
import Cookies from 'js-cookie';

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [token, setToken] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Check for existing token
    const storedToken = localStorage.getItem('metag_token');
    const storedUser = localStorage.getItem('metag_user');
    
    if (storedToken && storedUser) {
      setToken(storedToken);
      setUser(JSON.parse(storedUser));
    }
    setLoading(false);
  }, []);

  const login = (accessToken, userData) => {
    setToken(accessToken);
    setUser(userData || { username: 'user' });
    localStorage.setItem('metag_token', accessToken);
    localStorage.setItem('metag_user', JSON.stringify(userData || { username: 'user' }));
  };

  const logout = () => {
    setToken(null);
    setUser(null);
    localStorage.removeItem('metag_token');
    localStorage.removeItem('metag_user');
  };

  const updateUser = (userData) => {
    const updated = { ...user, ...userData };
    setUser(updated);
    localStorage.setItem('metag_user', JSON.stringify(updated));
  };

  // Save QR code to cookie
  const saveQRCode = (code) => {
    Cookies.set('metag_qr_code', code, { expires: 7 });
  };

  // Get QR code from cookie
  const getQRCode = () => {
    return Cookies.get('metag_qr_code');
  };

  // Clear QR code after association
  const clearQRCode = () => {
    Cookies.remove('metag_qr_code');
  };

  return (
    <AuthContext.Provider value={{
      user,
      token,
      loading,
      isAuthenticated: !!token,
      login,
      logout,
      updateUser,
      saveQRCode,
      getQRCode,
      clearQRCode
    }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth must be used within an AuthProvider');
  }
  return context;
};
